module.exports = __webpack_public_path__ + "img/Milk collection Center - Gadhinglaj.2ea8e2af.jpg";